export default {
  name: 'dashify:CardWithTitle',
  title: 'Card with title',
  owner: 'System',
  solution: '',
  tags: ['widget', 'card', 'title'],
  createdAt: 'Jul 30, 2023, 10:14 AM',
  updatedAt: 'Jan 11, 2024, 6:33 PM',
  spec: {
    props: {
      span: 4,
      rows: 1,
      font: 'font-medium',
      color: 'default-text',
      background: 'default-bg-weak',
      title: 'Card Title',
    },
    customClassName: '/${ $applyCustomBgColor(props.className, props.background) }',
    view: [
      {
        instanceOf: 'div',
        className:
          '/${ "h-full shadow-card relative rounded-lg overflow-auto pt-2 px-5 pb-5 col-span-" & props.span & " " & customClassName }',
        children: [
          [
            'div',
            { '.': 'h-full' },
            [
              [
                'div',
                { '.': 'h-[36px]' },
                [
                  [
                    'div',
                    {
                      '.': '/${ "leading-[15px] font-sans min-h-[36px] flex items-center" & " " & props.font }',
                    },
                    [['div', { '.': '/${ props.color }' }, '/${ props.title }']],
                  ],
                ],
              ],
              ['div', { '.': 'h-[calc(100%-36px)]' }, '/${ children }'],
            ],
          ],
        ],
      },
    ],
  },
};
